import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  acceptAnalytics,
  emitConsentChange,
  getConsent,
  rejectAnalytics,
} from '../consent'
import './ConsentBanner.css'

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setVisible(getConsent() === null)

    const onChange = () => setVisible(getConsent() === null)
    window.addEventListener('st:consent', onChange)
    return () => window.removeEventListener('st:consent', onChange)
  }, [])

  if (!visible) return null

  const onAccept = () => {
    acceptAnalytics()
    emitConsentChange()
    setVisible(false)
  }

  const onReject = () => {
    rejectAnalytics()
    emitConsentChange()
    setVisible(false)
  }

  return (
    <div className="consent-banner" role="dialog" aria-labelledby="consent-title" aria-live="polite">
      <div className="consent-banner__inner">
        <div className="consent-banner__text">
          <p id="consent-title" className="consent-banner__title">
            Cookies til statistik
          </p>
          <p className="consent-banner__body">
            Vi bruger valgfrie cookies til at måle, hvordan sitet bruges (sidevisninger
            og tilbagevendende besøg). Uden dit samtykke sætter vi ingen statistik-cookies.
            Nødvendige cookies til selve valget gemmes, når du svarer.{' '}
            <Link to="/privatliv">Læs mere</Link>
          </p>
        </div>
        <div className="consent-banner__actions">
          <button type="button" className="consent-btn consent-btn--reject" onClick={onReject}>
            Kun nødvendige
          </button>
          <button type="button" className="consent-btn consent-btn--accept" onClick={onAccept}>
            Accepter statistik
          </button>
        </div>
      </div>
    </div>
  )
}
